import { render, staticRenderFns } from "./EditContestModal.vue?vue&type=template&id=a979b79a"
import script from "./EditContestModal.vue?vue&type=script&lang=js"
export * from "./EditContestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports